import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from 'reducers';
var devToolsExtName = '__REDUX_DEVTOOLS_EXTENSION__';

var composeEnhancers = function composeEnhancers() {
  if (process.env.NODE_ENV === 'production' || typeof window === 'undefined' || !window || !window[devToolsExtName]) {
    return compose(applyMiddleware(thunkMiddleware));
  }

  return compose(applyMiddleware(thunkMiddleware), window[devToolsExtName]());
};

var configureStore = function configureStore() {
  var preloadedState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = createStore(rootReducer, preloadedState, composeEnhancers());

  if (module.hot) {
    module.hot.accept('../reducers', function () {
      /* eslint-disable-next-line global-require */
      var nextRootReducer = require('../reducers')["default"];

      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
};

export default configureStore;